export enum EIconStatus {
    CURRENT = 'current',
    UNANSWERED = 'unanswered',
    ANSWERED = 'answered',
}
